import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPage() {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 20px', color: 'var(--text)' }}>
      <Link to="/" style={{ color: 'var(--primary)', fontSize: '0.9rem', textDecoration: 'none' }}>
        ← 돌아가기
      </Link>

      <h1 style={{ fontSize: '1.6rem', marginTop: 16, marginBottom: 8 }}>개인정보처리방침</h1>
      <p style={{ color: '#8B8B9E', fontSize: '0.85rem', marginBottom: 32 }}>시행일: 2026년 5월 20일</p>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>1. 수집하는 개인정보 항목</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          keunson(이하 "서비스")은 서비스 제공을 위해 다음의 개인정보를 수집합니다.
        </p>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>회원가입 시: 이메일 주소, 비밀번호(암호화 저장), 닉네임</li>
          <li>서비스 이용 시: 투네이션 알림박스 URL, 펀네이션 크리에이터 ID</li>
          <li>YouTube 연동 시: YouTube 채널 정보, OAuth 액세스 토큰</li>
          <li>자동 수집: 접속 IP, 접속 시간, 브라우저 정보</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>2. 개인정보의 수집 및 이용 목적</h2>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>회원 식별 및 서비스 제공</li>
          <li>실시간 후원 데이터 수집 및 분석</li>
          <li>시청자 랭킹 및 큰손 알림 서비스 제공</li>
          <li>서비스 개선 및 통계 분석</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>3. 개인정보의 보유 및 이용 기간</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          회원 탈퇴 시 즉시 파기합니다. 단, 관계 법령에 의해 보존이 필요한 경우 해당 기간 동안 보관합니다.
        </p>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>계약 또는 청약철회 등에 관한 기록: 5년</li>
          <li>접속 로그 기록: 3개월</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>4. 개인정보의 제3자 제공</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          서비스는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 법령에 의해 요구되는 경우에는 예외로 합니다.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>5. 개인정보의 파기 절차 및 방법</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          전자적 파일 형태의 정보는 복구할 수 없는 방법으로 영구 삭제하며, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각합니다.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>6. 개인정보 보호 조치</h2>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>비밀번호는 bcrypt 알고리즘으로 암호화하여 저장</li>
          <li>SSL/TLS를 통한 데이터 전송 암호화</li>
          <li>JWT 기반 인증으로 무단 접근 방지</li>
          <li>Rate Limiting을 통한 무차별 공격 방지</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>7. 이용자의 권리</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          이용자는 언제든지 자신의 개인정보를 조회, 수정, 삭제할 수 있으며, 회원 탈퇴를 요청할 수 있습니다.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>8. 개인정보 보호책임자</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          성명: SAGUO<br />
          이메일: saguo.dot@gmail.com
        </p>
      </section>

      <section style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>9. 개인정보처리방침의 변경</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          본 방침은 시행일로부터 적용되며, 변경 사항이 있을 경우 서비스 내 공지를 통해 안내합니다.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPage;
